import { Users, ChevronDown, User, Building2, ExternalLink } from "lucide-react";

interface StakeholderInfo {
  pic_nama?: string;
  pic_jabatan?: string;
  unit_kerja?: string;
  stakeholder_eksternal: string[];
  hierarki: string[];
}

interface StakeholderMapPanelProps {
  data: StakeholderInfo;
}

export default function StakeholderMapPanel({ data }: StakeholderMapPanelProps) {
  return (
    <div className="rounded-xl border border-gray-200 bg-white shadow-sm">
      {/* Header */}
      <div className="flex items-center gap-2 px-4 py-3 bg-indigo-50 border-b border-indigo-100">
        <Users className="h-4 w-4 text-indigo-600" />
        <h3 className="text-sm font-bold text-indigo-800">STAKEHOLDER MAP</h3>
        <span className="text-xs text-indigo-500 ml-1">(D02 - Organisasi)</span>
      </div>

      <div className="p-4 space-y-4">
        {/* Hierarki Organisasi */}
        {data.hierarki.length > 0 && (
          <div>
            <p className="text-xs text-gray-500 uppercase tracking-wide font-medium mb-2">
              Hierarki Organisasi
            </p>
            <div className="space-y-0">
              {data.hierarki.map((level, index) => (
                <div key={index}>
                  <div
                    className="flex items-center gap-2 rounded-lg bg-gray-50 px-3 py-2"
                    style={{ marginLeft: index * 16 }}
                  >
                    <Building2 className="h-3.5 w-3.5 text-indigo-500 flex-shrink-0" />
                    <span className="text-sm text-gray-800 font-medium">{level}</span>
                  </div>
                  {index < data.hierarki.length - 1 && (
                    <div className="flex justify-center" style={{ marginLeft: index * 16 + 12 }}>
                      <ChevronDown className="h-3.5 w-3.5 text-gray-300" />
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        )}

        {/* PIC Utama */}
        {data.pic_nama && (
          <div>
            <p className="text-xs text-gray-500 uppercase tracking-wide font-medium mb-2">
              PIC Utama
            </p>
            <div className="flex items-center gap-3 rounded-lg bg-blue-50 px-3 py-2.5">
              <div className="h-8 w-8 rounded-full bg-blue-200 flex items-center justify-center flex-shrink-0">
                <User className="h-4 w-4 text-blue-700" />
              </div>
              <div>
                <p className="text-sm font-medium text-gray-900">{data.pic_nama}</p>
                {data.pic_jabatan && (
                  <p className="text-xs text-gray-500">{data.pic_jabatan}</p>
                )}
                {data.unit_kerja && (
                  <p className="text-xs text-blue-600">{data.unit_kerja}</p>
                )}
              </div>
            </div>
          </div>
        )}

        {/* Stakeholder Eksternal */}
        {data.stakeholder_eksternal.length > 0 && (
          <div>
            <p className="text-xs text-gray-500 uppercase tracking-wide font-medium mb-2">
              Stakeholder Eksternal
            </p>
            <div className="space-y-1">
              {data.stakeholder_eksternal.map((name, index) => (
                <div
                  key={index}
                  className="flex items-center gap-2 rounded-lg px-3 py-1.5 text-sm text-gray-700 hover:bg-gray-50"
                >
                  <ExternalLink className="h-3 w-3 text-gray-400 flex-shrink-0" />
                  {name}
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
